import { axiosInstance } from './index';
import { updateOTPFormType, userOTPResponseType, validateOTPFormType } from '../../types/userOtp';
import { ForgotPasswordType } from '../../types/customAuth';

export const userOtpService = {
    async updateUserOtp(params: updateOTPFormType) {
        const { data } = await axiosInstance.post(`User/UpdateUserOTP`, params);

        return data as userOTPResponseType;
    },

    async updateHRMSUserOtp(params: updateOTPFormType) {
        const { data } = await axiosInstance.post(`HRMSUser/GetHRMSOTP`, params);

        return data as userOTPResponseType;
    },

    async validateOTP(params: validateOTPFormType) {
        const { data } = await axiosInstance.post(`User/ValidateOTP`, params);
        return data as userOTPResponseType;
    },

    async validateHRMSOTP(params: validateOTPFormType) {
        const { data } = await axiosInstance.post(`HRMSUser/ValidateHRMSOTP`, params);
        return data as userOTPResponseType;
    },

    async uploadPolicyDocument(params: FormData) {
        await axiosInstance.post(`User/UploadPolicyDocuments`, params);
    },

    async uploadHRMSPolicyDocument(params: FormData) {
         await axiosInstance.post(`HRMSUser/UploadHRMSPolicyDocuments`, params);
    },
    async getHRMSForgotPassword(param: ForgotPasswordType) {
         await axiosInstance.post(`HRMSUser/HRMSForgotPassword`, param);
        // return data as CustomSignUpOtpResponseType;
    },
};
